// extracted by mini-css-extract-plugin
export var container = "_tm-0";
export var table = "_tm-2";
export var tableWrapper = "_tm-1";